angular.module('clients', ['core', 'user', 'client-group', 'client-feature', 'acquisition-source', 'industry-type', 'paymentmethods', 'paymentdeadlines', 'purchase-frequency', 'country',
    'gus-registry', 'vies-registry', 'deal', 'document', 'note', 'offers'])
    .constant('ClientConst', {
        eventUpdate: 'client.update'
    })
    .factory('Client', function ($resource) {
        return $resource('/crm/api/client/:id', {id: '@id'}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            table: {method: 'GET', isArray: false, url: '/crm/api/client/table'},
            duplicationCheck: {method: 'POST', isArray: true, url: '/crm/api/client/duplication-check'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/client/find'},
            remove: {method: 'DELETE'},
            categories: {method: 'GET', isArray: true, url: '/crm/api/client-category'},
            statuses: {method: 'GET', isArray: true, url: '/crm/api/client-status'},
            contacts: {method: 'GET', isArray: true, url: '/crm/api/client/:id/contacts'},
            addresses: {method: 'GET', isArray: true, url: '/crm/api/client/:id/addresses'}
        })
    })
    .service('ClientService', function ($rootScope, toastr, Client, $location, modals, ClientConst) {
        this.addModal = (options) => {
            let entity = {
                status: 'ACTIVE',
                type: 'COMPANY',
                id: null,
                contacts: [],
                addresses: [],
                bankAccounts: []
            }
            angular.extend(entity, options)
            return edit_modal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.symbol, () => Client.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(ClientConst.eventUpdate)))
        }
        this.edit = (id, options) => {
            return Client.get({id: id}).$promise.then(entity => {
                if (options && angular.isFunction(options.beforeOpen)) {
                    options.beforeOpen(entity)
                }
                return edit_modal(entity)
            })
        }
        this.show = id => $location.path("/clients/" + id)

        function edit_modal(entity) {
            return modals.open('app/clients/edit-modal.html', 'ClientDialogController', entity, {size: 'lg'}, "$ctrl")
        }
    })
    .controller("ClientDialogDuplicatesController", function ($uibModalInstance, data) {
        this.$onInit = () => {
            this.clients = data
        }
        this.choose = client => $uibModalInstance.close(client)
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_CLIENTS",
            path: "/clients",
            ico: "fa fa-fw fa-industry",
            name: 'menu.contractors',
            order: 10
        })
    })
    .config(function ($stateProvider) {
        $stateProvider.state('clientList', {
            parent: 'app',
            url: '/clients?{page:int}&{size:int}&sort&search&{group:int}&{feature:int}&category&status&{acquisitionSource:int}&{industryType:int}&leadOnly',
            data: {
                authorities: ['ROLE_CLIENTS']
            },
            views: {
                'content@': 'clientList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Client, $stateParams) => Client.table(angular.copy($stateParams)).$promise
            }
        })
        $stateProvider.state('clientShow', {
            parent: 'app',
            url: '/clients/{id}?{page:int}&{size:int}',
            data: {
                authorities: ['ROLE_CLIENTS']
            },
            views: {
                'content@': 'clientShow'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                item: (Client, $stateParams) => Client.get({id: $stateParams.id}).$promise
            }
        })
    })
